import React from "react";
import UserList from "./UserList";
import SearchBar from "./SearchBar";
import useSelector from "store/useSelector";
import AddUserModal from "./AddUserModal";
import FlowLayout from "components/layout/FlowLayout";

const UserManagement: React.FC = () => {
  const modalData = useSelector(store => store.userManagement.addUserModalData);

  return (
    <FlowLayout
      header={
        <SearchBar />
      }
    >
      <UserList />
      {modalData.isOpen &&
        <AddUserModal />
      }
    </FlowLayout>
  );
}

export default UserManagement;